import { usePage } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'

export function useTenant() {
  const { props } = usePage()

  const tenant = computed(() => props.value?.tenant)

  return {
    tenant
  }
}
